import React from "react";
import { Skeleton } from "antd";

const SkeletonForm = ({ fields = 6, showButtons = true }) => {
  return (
    <div style={{ padding: "12px", maxWidth: "100%" }}>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {Array.from({ length: fields }).map((_, index) => (
          <div
            key={index}
            style={{ display: "flex", flexDirection: "column", gap: "8px" }}
          >
            <Skeleton.Input
              active
              size="small"
              style={{ width: "30%", height: 14, marginBottom: "8px" }}
            />
            <Skeleton.Input
              active
              size="large"
              style={{ width: "100%", height: 40 }}
            />
          </div>
        ))}
      </div>

      {showButtons && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "24px",
            paddingTop: "24px",
            borderTop: "1px solid #f0f0f0",
          }}
        >
          <Skeleton.Button active size="large" style={{ width: 100 }} />
          <Skeleton.Button active size="large" style={{ width: 120 }} />
        </div>
      )}
    </div>
  );
};

export default SkeletonForm;
